// This is a standalone config object in ESM format to be used across
// vanilla and React code, where we don't need the full theme.
// This is the first step to fully remove theme.
// Keep in sync with src/domain/theme/themeConfig.js
export const breakpoints = [
  { name: 'mobile', width: 768 },
  { name: 'tablet', width: 1024 },
  { name: 'small_desktop', width: 1280 },
  { name: 'large_desktop', width: 1600 }
];
